if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        // PhotoSwipe is for PDP zoom only. Strip the trigger element so the
        // custom element never connects inside <quick-add-modal>, and remove
        // the data-pswp-* attrs from any image links so they render as plain
        // anchors (the custom element's closest('quick-add-modal') guard is
        // belt-and-braces against the same case).
        productElement.querySelectorAll('bb-product-lightbox').forEach((el) => el.remove());
        productElement.querySelectorAll('a[data-pswp-width]').forEach((a) => {
          a.removeAttribute('data-pswp-width');
          a.removeAttribute('data-pswp-height');
        });
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

// runs once on load + on resize, in case fonts or break-points change heights
function refreshQuickAddHeights() {
  document.querySelectorAll('.product-card-wrapper').forEach((wrapper) => {
    const qa = wrapper.querySelector('.quick-add');
    if (!qa) return;

    // include margins if you want them in the slide distance
    const qaHeight = qa.offsetHeight; // or qa.getBoundingClientRect().height
    wrapper.style.setProperty('--qa-height', `${qaHeight}px`);
  });
}

window.addEventListener('load', refreshQuickAddHeights);
window.addEventListener('resize', refreshQuickAddHeights);

/* (optional but recommended) keep it updated if quick-add content changes
   e.g. variant swatches collapsing/expanding or “Sold out” text toggling */
const ro = new ResizeObserver(refreshQuickAddHeights);
document.querySelectorAll('.quick-add').forEach((el) => ro.observe(el));

// Update hidden variant inputs when variant changes
function quickAddVariantChange(event) {
  const target = event.target;

  // Only handle radio button changes for variant options
  if (target.type !== 'radio') return;

  const variantId = target.dataset.variantId;
  console.log('variantId: ', variantId);

  // Find the product form that contains this variant picker
  const productForm = target.closest('form');
  if (!productForm) return;

  // Find the hidden variant input in this form
  const variantInput = productForm.querySelector('input[name="id"]');
  if (!variantInput) return;

  variantInput.value = variantId;
  // variantInput.dispatchEvent(new Event('change', { bubbles: true }));
}

// Add an event listener that fires when any quick add variant picker is changed
document.addEventListener('change', quickAddVariantChange);
